import { useState, useEffect } from "react";
import "./HealthOneTestimonial.scss";
import { FaChevronRight, FaPencilAlt, FaTrashAlt } from "react-icons/fa";
import AddTestimonials from "../../../../default-hooks/addTestimonials";
import { useCollection } from "../../../../firebase-files/hooks/useCollection";
import { useAuthContext } from "../../../../firebase-files/hooks/useAuthContext";
import { useDocument } from "../../../../firebase-files/hooks/useDocument";
import { useFirestore } from "../../../../firebase-files/hooks/useFirestore";
import UpdateTestimonial from "../../../../default-hooks/UpdateTestimonial";
import Rating from "@mui/material/Rating";
import StarIcon from "@mui/icons-material/Star";

const HealthOneTestimonial = () => {
  const { user } = useAuthContext();
  const [startIndex, setStartIndex] = useState(0);
  const [editingTestimonial, setEditingTestimonial] = useState(null);
  const [userMap, setUserMap] = useState({});
  const itemsPerPage = 3;

  const { documents: testimonials } = useCollection("testimonials");
  const { documents: allUsers } = useCollection("users");
  const { deleteDocument } = useFirestore("testimonials");

  const userPhone = user?.phoneNumber?.replace("+91", "91") || "";
  const { document: userInfo } = useDocument("users", userPhone);

  useEffect(() => {
    if (allUsers) {
      const map = {};
      allUsers.forEach((u) => {
        map[u.id] = u;
      });
      setUserMap(map);
    }
  }, [allUsers]);

  const handleNext = () => {
    if (!testimonials) return;
    setStartIndex((prev) =>
      prev + itemsPerPage >= testimonials.length ? 0 : prev + itemsPerPage
    );
  };

  const filteredTestimonials = testimonials?.filter((t) => {
    if (userInfo?.role === "admin") return true;
    return t.status === "active";
  }) || [];

  const visibleTestimonials = filteredTestimonials.slice(startIndex, startIndex + itemsPerPage);
  const currentPage = filteredTestimonials.length > 0
    ? Math.floor(startIndex / itemsPerPage) + 1
    : 1;
  const totalPages = Math.ceil(filteredTestimonials.length / itemsPerPage);

  return (
    <div className="health-one-testimonial-section">
      <div className="header">
        <div className="left">
          <p className="label">TESTIMONIALS</p>
          <h2 className="health-one-common-white-parent-heading">
            Voices from the Frontlines of Indian Healthcare
          </h2>
        </div>
        <div className="right">
          <div className="pagination">
            <span>{`0${currentPage}/0${totalPages}`}</span>
            <div className="arrow" onClick={handleNext}>
              <FaChevronRight size={20} />
            </div>
          </div>
        </div>
      </div>

      <div className="testimonial-cards">
        {visibleTestimonials.length > 0 ? (
          visibleTestimonials.map((t, i) => {
            const testimonialUser = userMap[t.createdBy];
            return (
              <div className="card" key={i}>
                {userInfo?.role === "admin" && (
                  <div className="admin-icons">
                    <FaPencilAlt
                      className="edit-icon"
                      size={12}
                      onClick={() => setEditingTestimonial(t)}
                      style={{ marginRight: "10px", cursor: "pointer" }}
                    />
                    <FaTrashAlt
                      className="delete-icon"
                      size={12}
                      onClick={() => deleteDocument(t.id)}
                     
                    />
                  </div>
                )}
                <p className="quote">“{t.description}”</p>
                <div className="author">
                  <img
                    src={testimonialUser?.photoURL || "https://via.placeholder.com/60"}
                    alt={testimonialUser?.fullName || "User"}
                  />
                  <div>
                    <p className="name">{testimonialUser?.fullName || "Anonymous"}</p>
                    <p className="role">{t.role}</p>
                  </div>
                </div>
              </div>
            );
          })
        ) : (
          <p>No testimonials available yet.</p>
        )}
      </div>

      {user && userInfo && <AddTestimonials />}

      {editingTestimonial && (
        <UpdateTestimonial
          testimonial={editingTestimonial}
          onClose={() => setEditingTestimonial(null)}
        />
      )}
    </div>
  );
};

export default HealthOneTestimonial;
